export const createAppSlice = (set: any, get: any) => ({
  store: {}
});